import { render } from "./UserKaryawan.vue?vue&type=template&id=3551a2a9"
import script from "./UserKaryawan.vue?vue&type=script&lang=js"
export * from "./UserKaryawan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__